import { createContext, Dispatch, SetStateAction, useContext } from 'react';
import { RequestType } from 'models/item-request.model';

export type KitchenItemRequestContextType = {
  setItemRequestToEdit: Dispatch<SetStateAction<RequestType>>;
  itemRequestToEdit: RequestType;
};

export const KitchenItemRequestContext = createContext({} as KitchenItemRequestContextType);
const useKitchenItemRequestContext = () => {
  const context = useContext(KitchenItemRequestContext);
  return context;
};

export default useKitchenItemRequestContext;
